<button
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  mat-button
  type="button"
  (click)="triggerOverlay()"
>
  <mat-icon class="!m-auto" customMatSvgIcon="pct-mdi-cog" />
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="overlayOpened()"
  [cdkConnectedOverlayOrigin]="trigger"
  (overlayOutsideClick)="triggerOverlay()"
>
  <pct-feature-table-material-settings-overlay
    [columns]="columns()"
    [config]="config()"
    [displayedColumns]="displayedColumns()"
    [tableId]="tableId()"
    (finished)="triggerOverlay()"
  />
</ng-template>
